import Column from '@components/Column';
import styled from '@emotion/styled';
// import Tooltip from '@components/Tooltip';

import PickIcon from './PickIcon';

interface Props {
    isScrolling: boolean;
}

function PickButton({ isScrolling }:Props) {
    return (
        <Container align='center' spacing={6}
            style={{ opacity: isScrolling ? 0.8 : 1 }} >
            <PickIcon/>
            <Label>
                골라담기
            </Label>
        </Container>
    );
    /*
  return (
        <Link href={{ pathname: '/items', query: { type: 'myMenu' } }}
              className={styles.wrapper} >
            <Column align='center' spacing={6}
                    className={styles.container}
                    style={{ opacity: isScrolling ? 0.8 : 1 }} >
                <PickIcon/>
                <button className={styles.button}>
                    골라담기
                </button>
            </Column>
        </Link>
  );

     */
}

const Container = styled(Column)`
    position: relative;
    transition: opacity 300ms;
`;

const Label = styled.button`
    background-color: var(--color-gray6);
    border-radius: 20px;
    color: var(--color-white);
    font-size: 14px;
    line-height: 20px;
    padding: 3px 10px;
    white-space: nowrap;
`;

export default PickButton;
